import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    productGrid: {
        flexGrow: 1,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
    },
    deliveryPassGridItem: {
        display: 'flex',
        flexGrow: 0,
        maxWidth: '407px',
        flexBasis: '407px !important',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            maxWidth: '50%',
            paddingBottom: '12px',
        },
        '&:last-child': {
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '12px',
            },
        },
    },
    favoriteButtonWrapper: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        zIndex: 10,
        overflow: 'visible',
    },
    favoriteButtonImageOverlay: {
        position: 'absolute',
        top: spacing.xxs,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '384px', // Match ProductCard MAX_CARD_WIDTH
        width: '100%',
        zIndex: 1,
        pointerEvents: 'none',
        overflow: 'visible',
        '& > div[role="button"]': {
            pointerEvents: 'auto',
            position: 'absolute',
            top: 0,
            right: spacing.xxs,
            overflow: 'visible',
            zIndex: 1,
        },
        '& > div[role="button"] > *': {
            overflow: 'visible',
        },
        '& > *': {
            pointerEvents: 'auto',
            position: 'absolute',
            top: 0,
            right: spacing.xxs,
            overflow: 'visible',
        },
        [theme.breakpoints.up('md')]: {
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
    invisibleIconButtonAnchor: {
        position: 'absolute',
        top: 0,
        right: spacing.xs,
        width: 40,
        height: 40,
        pointerEvents: 'none',
    },
    gridItemRedesign: {
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
}));
export default useStyles;
